module.exports = __webpack_public_path__ + "img/15.f291defc.jpeg";